import { useState } from "react";
import { RecipeListing, type RecipeListingSearchParams } from "@/components/recipes/RecipeListing";

const DEFAULT_PARAMS: RecipeListingSearchParams = {
  source: "all",
};

export function RegionRecipesTab({ regionId }: { regionId: number }) {
  const [searchParams, setSearchParams] = useState<RecipeListingSearchParams>(DEFAULT_PARAMS);

  return (
    <RecipeListing
      regionId={regionId}
      searchParams={searchParams}
      onNavigate={(updater) => setSearchParams((prev) => updater(prev))}
    />
  );
}
